import { istanbulDayString } from '@aquabox/shared';

/**
 * Ay sonu raporu (PDF) — panel istemcisi.
 *
 * Bu dosya YALNIZ ay seçimi ve yol üretir. RAPOR İÇERİĞİ ve PARA HESABI SUNUCUDADIR
 * (kural 4): panel tutar toplamaz, yalnız indirir.
 *
 * AY ANAHTARI İSTANBUL AYYDIR (kural 8): 21:00Z'de İstanbul'da yeni ay başlamış olabilir;
 * ay listesi UTC'ye göre kurulursa "geçen ay" seçeneği yanlış ayı gösterir.
 */

export interface MonthOption {
  /** "YYYY-MM" */
  value: string;
  /** "Ekim 2026" */
  label: string;
}

/** İstanbul'da içinde bulunulan ayın anahtarı. */
export function currentMonthKey(now: Date = new Date()): string {
  return istanbulDayString(now).slice(0, 7);
}

/** TAMAMLANMIŞ son ayın anahtarı — ay sonu raporunun varsayılanı. */
export function previousMonthKey(now: Date = new Date()): string {
  const [y, m] = currentMonthKey(now).split('-').map(Number) as [number, number];
  const prev = m === 1 ? { y: y - 1, m: 12 } : { y, m: m - 1 };
  return `${prev.y}-${String(prev.m).padStart(2, '0')}`;
}

/** "2026-10" → "Ekim 2026". Ay adı Türkçe. */
export function monthLabel(month: string): string {
  const [y, m] = month.split('-').map(Number) as [number, number];
  return new Intl.DateTimeFormat('tr-TR', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(new Date(Date.UTC(y, m - 1, 1)));
}

/**
 * Seçilebilir aylar — içinde bulunulan ay dahil son `count` ay, YENİDEN ESKİYE.
 *
 * `count` 12: bir yıllık geçmiş. Daha eski bir ay istenirse API yine üretir; seçici
 * pratikte bir yılı gösterir.
 */
export function monthOptions(count = 12, now: Date = new Date()): MonthOption[] {
  const [y, m] = currentMonthKey(now).split('-').map(Number) as [number, number];
  const out: MonthOption[] = [];
  for (let i = 0; i < count; i += 1) {
    const d = new Date(Date.UTC(y, m - 1 - i, 1));
    const key = `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
    out.push({ value: key, label: monthLabel(key) });
  }
  return out;
}

/** Rapor ucu — yol ve ay anahtarı. */
export function monthlyReportPath(month: string): string {
  return `/api/reports/monthly.pdf?month=${encodeURIComponent(month)}`;
}

/** İndirilecek dosya adı — sunucunun ürettiği adla AYNI olmalı. */
export function monthlyReportFilename(month: string): string {
  return `ay-sonu-${month}.pdf`;
}
